import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/auth/AuthProvider';

const AUTH_WAIT_TIMEOUT_MS = 10000;

export default function Home() {
  const router = useRouter();
  const { isAuthenticated, isCheckingAuth } = useAuth();
  const [authTimedOut, setAuthTimedOut] = useState(false);

  useEffect(() => {
    // Only redirect after auth check is complete
    if (!isCheckingAuth) {
      // If authenticated, redirect to dashboard; otherwise, redirect to login
      if (isAuthenticated) {
        router.push('/map');
      } else {
        router.push('/login');
      }
    }
  }, [router, isAuthenticated, isCheckingAuth]);

  // If the auth check stalls (e.g. MSAL iframe blocked, network issue), offer a way out
  useEffect(() => {
    if (!isCheckingAuth) return;
    const timer = setTimeout(() => setAuthTimedOut(true), AUTH_WAIT_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [isCheckingAuth]);

  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <div className="flex flex-col items-center gap-4 px-6 text-center">
        <div className="text-white text-lg font-medium">
          {authTimedOut ? 'This is taking longer than usual…' : 'Checking your sign-in…'}
        </div>
        {authTimedOut && (
          <>
            <p className="text-sm text-slate-400 max-w-sm">
              We couldn&apos;t confirm your Microsoft sign-in. You can keep waiting, or start
              the sign-in again.
            </p>
            <button
              onClick={() => router.push('/login')}
              className="rounded-md bg-white px-4 py-2 text-sm font-medium text-black hover:bg-slate-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              Sign in again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
